"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemIdentifier = void 0;
var SystemIdentifier;
(function (SystemIdentifier) {
    SystemIdentifier["Skeletal"] = "34ffceb85c04ee0889b0e62d51e6b238";
    SystemIdentifier["ConnectiveT"] = "790f0089ea8bb4198810e8c7f273244a";
    SystemIdentifier["Muscular"] = "82160f3581673bf243013bd0752f97e7";
    SystemIdentifier["Arterial"] = "8363066509a93dd808401b5a852da8ad";
    SystemIdentifier["Venous"] = "3c058090c292540150309cb4b144a8be";
    SystemIdentifier["Lymphatic"] = "d40521e67b25a5e9a194ba7a5cdc8924";
    SystemIdentifier["Nervous"] = "7b69bb6d7d12fef97ce11bda6d5ec603";
    SystemIdentifier["Respiratory"] = "66016a3890b56bc84c83aef0e9931abc";
    SystemIdentifier["Digestive"] = "a36a931308c6000f417ee2a296073ada";
    SystemIdentifier["Endocrine"] = "171c2a918ba95b74e90a3448ddde9601";
    SystemIdentifier["Urogenital"] = "80b4a57960119b20a7a26524250ca870";
    SystemIdentifier["Integumentary"] = "a62ced19ffc2946de29a68a80400363d";
})(SystemIdentifier || (exports.SystemIdentifier = SystemIdentifier = {}));
